import React, {
  ComponentType,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  IconButton,
  Stack,
} from '@mui/material';
import api from '../../services/api';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import {
  DataGridPro, GridColDef, GridFilterModel,
  GridFooter, GridPaginationModel, GridSortModel,
} from '@mui/x-data-grid-pro';
import {datagridColors} from '../../assets/datagridStyles';
import {useGridApiRef} from '@mui/x-data-grid';
import {enumItems} from '../../schema/enumItems';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import {Header} from "../AdminPages/Header";
import {SPSelectField} from "../../components/Table/fields/SPSelectField";
import ReactDOM from "react-dom";

const autosizeOptions = {
  includeHeaders: true,
  includeOutliers: true,
  outliersFactor: 1.5,
  expand: false,
};

export const SalesPartnerPrices: ComponentType = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const apiRef = useGridApiRef();

  useEffect(() => {
    document.title = `Zoe - Sales Partner Prices`;
  }, []);
  const fetchRows = useCallback(() => {
    setLoading(true);

    if (selectedOption?.id){
      api.get(`/sales-partners/${selectedOption.id}/prices`).then((res: any) => {

        setLoading(false);

        ReactDOM.flushSync(() => {
          setRows(res);
          if (apiRef?.current) {
            apiRef.current.updateRows(res);
          }
        });

      })
        .then(() => sleep(0))
        .then(() => {
          if (apiRef?.current) {
            apiRef.current.autosizeColumns(autosizeOptions);
          }
        });
    }else{
      setLoading(false);
    }


  }, [selectedOption]);

  useEffect(() => {
    fetchRows();
  }, [selectedOption]);

  const [filterModelStatic, setFilterModelStatic] = useState<GridFilterModel>({
    items: [],
  });
  const [sortModelStatic, setSortModelStatic] = useState<GridSortModel>([]);
  const [paginationModelStatic, setPaginationModelStatic] = useState<
    GridPaginationModel
  >({
    page: 0,
    pageSize: 10,
  });


  const columns: GridColDef[] = useMemo(() => {
    const columnArray: GridColDef[] = [
      {
        field: 'actions',
        type: 'string',
        headerName: '',
        cellClassName: '',
        editable: false,
        width: 50,
        renderCell: (params: any) => {
          const currentPage = paginationModelStatic.page;
          const pageSize = paginationModelStatic.pageSize;

          const rowIndex =
            currentPage * pageSize +
            params.api.getRowIndexRelativeToVisibleRows(params.id) +
            1;

          const id = params.id;
          return (
            <>
              {rowIndex}
            </>
          );
        },
        renderHeaderFilter: () => {
          return <></>;
        },
      },
      {
        field: 'activity_name',
        headerName: 'Activity',
        editable: false,
        type: 'string',
        minWidth: 125,
        renderCell: (props: any) => {

          return (
            <div
              className={'flex gap-[5px]'}
              onClick={()=>{

                window.open(
                  `/activities/${props?.row?.activity_id}`,
                  "_blank",
                  "noopener,noreferrer"
                );

              }}
              style={{cursor: "pointer"}}
            >
              {props?.value}
            </div>
          );
        },
      },
    ];

    for (let i = 1; i < 51; i++) {
      columnArray.push(
        {
          field: `size_${i}`,
          headerName: `${i}`,
          editable: false,
          type: 'number',
        });
    }

    return columnArray;
  }, [
    rows,
    sortModelStatic,
    filterModelStatic,
    paginationModelStatic,
    apiRef
  ]);

  const CustomFooter = () => {
    return (
      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px',
        }}
      >
        <IconButton
          sx={{
            visibility: 'hidden'
          }}
          onClick={() => {

          }}
        >
          <AddIcon color={'primary'}/>
        </IconButton>

        <GridFooter/>
      </Stack>
    );
  };

  function CustomSortIconDesc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropDownRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  function CustomSortIconAsc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  function CustomSortIcon(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }


  const handleFilterModelChange = useCallback((newModel: any) => {
    setFilterModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  const handleSortModelChange = useCallback((newModel: any) => {
    setSortModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  const handlePaginationModelChange = useCallback((newModel: any) => {
    setPaginationModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  return (
    <>
      <Header
        title={'Sales Partner Prices'}
        rowCount={rows.length}
        hasPagination={false}
      />

      <Stack
        direction="row"
        justifyContent={'space-between'}
        sx={{
          background: '#fff',
          borderRadius: '10px',
          boxShadow: '0px 0px 10px -5px #00000091',
          p: '10px',
          m: '10px',
          '& .MuiStack-root>:not(style)~:not(style)': {
            marginLeft: '0px !important',
          },
        }}
      >
        <Stack
          direction={'row'}
          gap={1}
          alignItems={'center'}
          justifyContent={'start'}
        >
         <Box
         sx={{
           width: '200px',
           '@media (max-width:600px)': {
             width: '100%',
           },
         }}>
           <SPSelectField onChange={(value)=>{
             setSelectedOption(value);
           }}
                          schema={enumItems.salesPartner}
                          defaultValue={null}
                          forcedValue={null}
                          disabled={false}
                          isMissing={false}
                          accordingToValue={null}
                          title={'Sales Partner'}
           />
         </Box>
        </Stack>
      </Stack>

      <Box sx={datagridColors('calc(100vh - 145px)')}>
        <DataGridPro
          apiRef={apiRef}
          sx={{
            pointerEvents: loading ? 'none' : 'auto',
            opacity: loading ? 0.5 : 1,
            maxHeight: 'calc(100% - 70px)',
          }}
          rows={rows}
          getRowClassName={(params: any) => {
            const color =
              params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
            return `${color}`;
          }}
          disableColumnMenu={true}
          columns={columns}
          loading={loading}
          getRowHeight={()=>20}
          disableRowSelectionOnClick
          columnHeaderHeight={38}
          rowHeight={38}
          pagination
          slots={{
            // @ts-ignore
            columnSortedDescendingIcon: CustomSortIconDesc,
            columnSortedAscendingIcon: CustomSortIconAsc,
            columnUnsortedIcon: CustomSortIcon,
            footer: CustomFooter,
            headerFilterMenu: null,
          }}
          unstable_headerFilters={true}
          pageSizeOptions={[25, 50, 100, {label: 'All', value: rows.length}]}
          initialState={{
            pinnedColumns: { left: ['actions','activity_name'], right: [] },
          }}
          filterMode={'client'}
          disableChildrenFiltering={true}
          onFilterModelChange={handleFilterModelChange}
          sortingMode={'client'}
          onSortModelChange={handleSortModelChange}
          disableMultipleColumnsSorting={false}
          onPaginationModelChange={handlePaginationModelChange}
        />
      </Box>

    </>
  );
};

function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
